export const INTENT_TYPES = {
	ERROR: 'error',
	SUCCESS: 'success',
	WARNING: 'warning',
};

export default {
	INTENT_TYPES,
};
